function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import className from 'classnames';
import Animate from 'rc-animate';
import PropTypes from 'prop-types';
export default function TargetList(props) {
  var data = props.data,
      renderProps = props.renderProps,
      prefixCls = props.prefixCls;
  var _renderProps$icon = renderProps.icon,
      icon = _renderProps$icon === void 0 ? false : _renderProps$icon,
      _renderProps$content = renderProps.content,
      content = _renderProps$content === void 0 ? '' : _renderProps$content,
      _renderProps$option = renderProps.option,
      option = _renderProps$option === void 0 ? false : _renderProps$option;

  var renderNode = function renderNode(type, item, _class) {
    if (type === false || type === null) return null;

    var _className = className("".concat(prefixCls, "-item-render"), _defineProperty({}, _class, _class));

    if (typeof type === 'function') {
      return React.createElement("div", {
        className: _className
      }, type(item));
    }

    return React.createElement("div", {
      className: _className
    }, item.title);
  };

  return React.createElement("div", {
    className: prefixCls
  }, React.createElement(Animate, {
    transitionName: "fade",
    component: "div",
    className: "".concat(prefixCls, "-ul")
  }, data.length > 0 ? data.map(function (item) {
    return React.createElement("div", {
      className: "".concat(prefixCls, "-item"),
      key: item.key
    }, renderNode(icon, item, 'icon'), renderNode(content, item), renderNode(option, item, 'right'));
  }) : React.createElement("div", {
    className: "".concat(prefixCls, "-nodata")
  }, "\u6682\u65E0\u76F8\u5173\u6570\u636E")));
}
TargetList.defaultProps = {
  prefixCls: 'mkui-abstract-transfer-target-list',
  renderProps: {}
};
TargetList.propTypes = {
  prefixCls: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.any.isRequired,
    title: PropTypes.string
  })),
  renderProps: PropTypes.shape({
    icon: PropTypes.renderNode,
    content: PropTypes.renderNode,
    option: PropTypes.renderNode
  })
};
//# sourceMappingURL=TargetList.js.map
